<template>
  <Card>
    <div slot="body">
      <h4 class="mb-3">ไฟล์อัพโหลดสำเร็จ</h4>
      <div class="my-4">
        <div class="d-flex align-items-center mb-3">
          
          <div class="text-muted mx-auto">
            พบ <span class="text-success font-weight-bold">{{ rowCount }}</span> รายการในไฟล์
          </div>
        </div>
        <div class="alert alert-info mx-auto" style="max-width: 600px;">
          <div class="font-weight-bold mb-2">ไฟล์ที่อัพโหลด:</div>
          <div style="font-family: monospace;">{{ fileName }}</div>
        </div>
      </div>

      <div class="text-center">
        <Button
          type="button"
          variant="primary"
          size="md"
          @click="$emit('validate-addresses')"
        >
          🔍 ตรวจสอบที่อยู่
        </Button>
      </div>
    </div>
  </Card>
</template>

<script>
import Card from "@/components/core/Card";
import Button from "@/components/core/Button";

export default {
  name: "FileUploadedScreen",
  components: { Card, Button },
  props: {
    rowCount: {
      type: Number,
      default: 0
    },
    fileName: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
